/* eslint-disable prettier/prettier */
import TeamService from "../services/TeamService";
import router from "../router";
import { checkToken } from "../utils/helpers";

const getDefaultState = () => ({
  team: {
    team_name: "",
    description: "",
    country: "",
    region: "",
    district: "",
    team_coordinator: null,
    trainers: [],
    trainer_names: [],
    coordinator_name: "",
    active: true,
    start_date: null,
    end_date: null
  },
  teams: [],
  teamTrainers: []
});

const teams = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    team_name(state, val) {
      state.team.team_name = val;
    },
    description(state, val) {
      state.team.description = val;
    },
    country(state, val) {
      state.team.country = val;
    },
    region(state, val) {
      state.team.region = val;
    },
    district(state, val) {
      state.team.district = val;
    },
    team_coordinator(state, val) {
      state.team.team_coordinator = val;
    },
    coordinator_name(state, val) {
      state.team.coordinator_name = val;
    },
    teamTrainers(state, val) {
      state.teamTrainers = val;
    },
    trainers(state, val) {
      state.team.trainers = val;
    },
    trainer_names(state, val) {
      state.team.trainer_names = val;
    },
    active(state, val) {
      state.team.active = val;
    },
    start_date(state, val) {
      state.team.start_date = val;
    },
    end_date(state, val) {
      state.team.end_date = val;
    },
    teams(state, val) {
      state.teams = val;
    },
    resetTeams(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async GET_TEAMS({ commit }) {

      let isSrc = localStorage.getItem('src');
      const local = checkToken() && JSON.parse(localStorage.getItem("userLogin"));
      let res;
      if(isSrc){
        res = await TeamService.fetchClusterTeams(local.uuid);
      }else{
        res = await TeamService.fetchTeams();
      }

      const data = res.data.results;
      commit("teams", data);
    },
    async GET_ONE_TEAM({ state }) {
      const res = await TeamService.getOneTeam(router.currentRoute.params.id);
      const data = res.data.results;
      if (data.length > 1) {
        const teamData = data[0];
        state.team = teamData;
        const trainersIds = [];
        const trainersNames = [];
        console.log(state.team);
        data.forEach(element => {
          if (element.coordinator_uuid) {
            state.team.team_coordinator = element.coordinator_uuid;
            state.team.coordinator_name = element.coordinator_name;
          }
          if (element.trainer_uuid) {
            trainersIds.push(element.trainer_uuid);
            trainersNames.push(element.trainer_name);
          }
        });
        // console.log(state.team);
        state.team.trainers = trainersIds;
        state.team.trainer_names = trainersNames;
      } else {
        state.team = data;
      }
    },
    async CREATE_TEAM({ state }) {
      const data = { ...state.team };
      delete data.id;
      delete data.trainer_names;
      delete data.coordinator_name;
      delete data.coordinator_uuid;
      delete data.trainer_name;
      delete data.trainer_uuid;

      console.log(data);
      const res = await TeamService.createTeam(data);
      console.log(res);
    },
    async UPDATE_TEAM({ state }) {
      const data = { ...state.team };
      delete data.trainer_names;
      delete data.coordinator_name;
      delete data.coordinator_uuid;
      delete data.trainer_name;
      delete data.trainer_uuid;
      delete data.trainers;
      delete data.team_coordinator;
      console.log(data);
      const res = await TeamService.updateTeam(data);
      console.log(res);
    },
    async GET_TEAM_TRAINERS(context) {
      const trainers = await TeamService.fetchTrainers({
        id: router.currentRoute.params.id
      });
      const data = trainers.data.results;
      context.commit("teamTrainers", data);
    },
    ADD_TRAINER: async (state, data) => {
      const res = await TeamService.addTrainer(data.id);
      console.log(res);
    },
    DELETE_TRAINER: async (state, data) => {
      console.log(data.id);
      const res = await TeamService.deleteTrainer(data.id);
      console.log(res);
    },
    async DELETE_TEAM(id) {
      const res = await TeamService.deleteTeam(id);
      console.log(res);
    },
    async RESET_TEAMS_STATE(context) {
      await context.commit("resetTeams");
    }
  },
  getters: {
    teamTrainersObj: state => {
      const trainersIds = state.team.trainers;
      const trainersNames = state.team.trainer_names;
      const results = [];
      // eslint-disable-next-line
      for (let i = 0; i < trainersIds.length; i++) {
        const obj = { id: trainersIds[i], trainer_name: trainersNames[i] };
        results.push(obj);
      }
      return results;
    },
    teamCoordinator: state => {
      const coordinatorId = state.team.team_coordinator;
      const coodrinatorName = state.team.coordinator_name;
      const obj = { id: coordinatorId, name: coodrinatorName };
      return obj;
    }
  }
};

export default teams;
